// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { unflattenOptions } from '../../option/utils/unflatten-options';
import { getItemProps } from './get-item-props';
import Item from './item';
import OptionGroup from './option-group';
export const renderOptions = ({ options, getOptionProps, filteringValue, highlightType, idPrefix, hasDropdownStatus, virtualItems, selectionType = 'single', screenReaderContent, ariaSetsize, withScrollbar, firstOptionSticky, stickyOptionRef, renderOption, }) => {
    const getNestedItemProps = ({ index, option }) => {
        const virtualItem = virtualItems && virtualItems[index];
        const globalIndex = virtualItem ? virtualItem.index : index;
        return getItemProps({
            option,
            index: globalIndex,
            getOptionProps,
            filteringValue: option.type === 'select-all' ? '' : filteringValue,
        });
    };
    const renderListItem = (props, index, parentProps) => {
        const virtualItem = virtualItems && virtualItems[index];
        const globalIndex = virtualItem ? virtualItem.index : index;
        const isLastItem = index === options.length - 1;
        const padBottom = !hasDropdownStatus && isLastItem;
        const isSticky = firstOptionSticky && globalIndex === 0;
        return (React.createElement(Item, { selectionType: selectionType, index: index, virtualIndex: virtualItem ? virtualItem.index : undefined, key: globalIndex, ...props, virtualPosition: virtualItem === null || virtualItem === void 0 ? void 0 : virtualItem.start, ref: isSticky && stickyOptionRef ? stickyOptionRef : virtualItem && virtualItem.measureRef, padBottom: padBottom, screenReaderContent: screenReaderContent, ariaPosinset: globalIndex + 1, ariaSetsize: ariaSetsize, highlightType: highlightType.type, withScrollbar: withScrollbar, sticky: isSticky, renderOption: renderOption, parentProps: parentProps }));
    };
    const unflattenedOptions = unflattenOptions(options);
    return unflattenedOptions.map(nestedDropdownOption => {
        var _a;
        const index = nestedDropdownOption.index;
        const props = getNestedItemProps(nestedDropdownOption);
        if (nestedDropdownOption.type === 'parent') {
            const { children } = nestedDropdownOption;
            const optionId = (_a = props.id) !== null && _a !== void 0 ? _a : `${idPrefix}-option-${index}`;
            return (React.createElement(OptionGroup, { key: `group-${index}`, virtual: (virtualItems === null || virtualItems === void 0 ? void 0 : virtualItems[index]) !== undefined, ariaLabelledby: optionId, ariaDisabled: props['aria-disabled'] },
                renderListItem(props, index),
                children.map(child => {
                    var _a, _b, _c, _d, _e, _f;
                    return (React.createElement(React.Fragment, { key: child.index }, renderListItem(getNestedItemProps(child), child.index, {
                        option: nestedDropdownOption.option,
                        disabled: (_a = nestedDropdownOption.option.disabled) !== null && _a !== void 0 ? _a : false,
                        index: index,
                        virtualIndex: (_c = (_b = virtualItems === null || virtualItems === void 0 ? void 0 : virtualItems[index]) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : undefined,
                        highlighted: (_d = props.highlighted) !== null && _d !== void 0 ? _d : false,
                        selected: (_e = props.selected) !== null && _e !== void 0 ? _e : false,
                        indeterminate: (_f = props.indeterminate) !== null && _f !== void 0 ? _f : false,
                    })));
                })));
        }
        return renderListItem(props, index);
    });
};
//# sourceMappingURL=render-options.js.map